import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setVolunteerRequest,  volunteer, saveVolunteer, cancelVolunteer} from '../../actions/volunteerActions';
import Dimmer from './Dimmer';
import ModalFrame from './ModalFrame';
import {colors} from './../../assets/theme';
import Location from './Location';
import { Button } from 'semantic-ui-react';
import { updateDonationUser } from '../../actions/inventoryActions';
import moment from 'moment';
import ItemTitle from './ItemTitle';
import ItemSubTitle from './ItemSubTitle';
import ItemSmallLogo from './ItemSmallLogo';
import Divider from './Divider';
import CharityHeader from './CharityHeader';
import VolunteerTimeSlot from './VolunteerTimeSlot';
import SectionLabel from './SectionLabel';
import TimeFormat from './TimeFormat';
import Logo from './Logo';

class VolunteerModal extends React.Component {

    constructor(props){
        super(props);
        this.createDonation  = this.createDonation.bind(this);
        this.saveDonation = this.saveDonation.bind(this);
        this.state = {
            donation : false,
            working :false,
            donated : false
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ 
        document.body.classList.add("_VolunteerModal_Open");
    }
    componentWillUnmount(){
        document.body.classList.remove("_VolunteerModal_Open");
    }

    createDonation(timeslotId){
        let {charityId, name} = this.props.request;
        let {title, requestId, locationId } = this.props.request.selectedRequest;
        this.props.volunteer(charityId, name, requestId, title, timeslotId, locationId);
    }

   
    async saveDonation(){
        if(this.state.working) return;
        try{
            this.setState({working : true});
            await this.props.saveVolunteer(this.props.donation);
            this.setState({working : false, donated : true});
        }
        catch(error){
            console.error(error);
            this.setState({working : false});
        }
    }
    render(){

        const renderDonationArea = ()=>{
            if(!this.props.donation) return null;

            if(this.state.donated){
                return (
                    <div>
                        <style jsx>{`
                             
                            .controls {
                                margin-top:10px;
                                text-align:center;
                            }
                            .response {
                                font-size:25px;
                                color:${colors.primary};
                                font-weight:700;
                                text-align:center;
                                margin:0;
                            }
                            .response-detail {
                                font-size:15px;
                                color:${colors.primary};
                                text-align:center;
                                margin:0;
                            }
                            .ref {
                                margin:10px 0px;
                                font-size:18px;
                                color:${colors.primary};
                                font-weight:700;
                                text-align:center;
                            }
                            .statement {
                                font-size:20px;
                                color:${colors.dark};
                                font-weight:400;
                                text-align:center;
                                margin:0;
                                
                            }
                        `}</style>

                            <div>
                                <div style={{maxWidth:120, margin:'auto'}}><Logo /></div>
                                <br/>
                                <p className="statement">Thank you{(this.props.donation.firstName)? ' '+this.props.donation.firstName:''}. Your offer of help has been sent. </p>
                                <br/>
                                <p className="statement">We have sent an email to you with further details.</p>
                                <br/>
                                <p className="ref">Volunteer Reference: {this.props.donation.ref}</p>
                            </div>
                            <div className="controls">
                    
                                
                                <Button size="large" primary
                                    fluid primary onClick={this.props.cancelVolunteer}>Done</Button>
                            </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <style jsx>{`
                             input {
                                border:1px solid ${colors.hiGrey};
                                font-size:14px;
                                width:100%;
                                padding:10px;
                                
                            }
    
                
                            .name-row {
                                display:flex;
                                justify-content: space-between;
                            
                            }
        
                
                            
                            .name-row input {
                                width:48%;
                                width:calc(50% - 5px);
                                margin-bottom:10px;
                            }
                            .controls {
                                margin-top:10px;
                                text-align:center;
                            }
                            .headerWrap {
                                background:${colors.primary};
                                padding:20px;
                                margin-right:-20px;
                                margin-top:-20px;
                                margin-left:-20px;
                                margin-bottom:20px;
                            }
                            .statement {
                                font-size:20px;
                                color:${colors.dark};
                                font-weight:400;
                                text-align:center;
                                margin:0;
                                
                            }

                            .response {
                                font-size:20px;
                                color:${colors.primary};
                                font-weight:700;
                                text-align:center;
                                margin:0;
                                
                            }
                            
                            .response-detail {
                                font-size:15px;
                                color:${colors.dark};
                                text-align:center;
                                margin:0;
                            }
                        `}</style>
                    

                        <div className="input">
                                <div style={{maxWidth:120, margin:'auto'}}><Logo /></div>
                                <br/>
                                <p className="statement">Enter your name and email address below to offer your help to {this.props.request.name}.</p>
                                <br/>
                                <p className="response">{this.props.request.selectedRequest.title}</p>
                                {
                                     this.props.request.selectedRequest.timeslots
                                        .filter((slot)=>{return (slot.id==this.props.donation.timeslotId)})
                                        .map((slot)=>{
                                            return (
                                               <div key={slot.id}>
                                                    <p className="response-detail"><TimeFormat stamp={slot.start} type="day" /></p>
                                                    <p className="response-detail">
                                                        <TimeFormat stamp={slot.start} type="time" />
                                                        {(slot.start && slot.end)?'-':''}
                                                        <TimeFormat stamp={slot.end} type="time" />
                                                    </p>
                                                    <br/>
                                               </div>
                                            )
                                        })
                                }
                                


                                <div className="name-row">
                                <input
                                value={this.props.user.firstName}
                                onChange={(e,d)=>{this.props.updateDonationUser('firstName', e.target.value)}}
                                type="text" required placeholder="First Name" />
                                <input
                                 value={this.props.user.lastName}
                                 onChange={(e,d)=>{this.props.updateDonationUser('lastName', e.target.value)}}
                                type="text" required placeholder="Last Name" />
                                </div>
                                
                                <input 
                                value={this.props.user.email}
                                onChange={(e,d)=>{this.props.updateDonationUser('email', e.target.value)}}
                                type="email" required placeholder="Email Address" />
                                
                            </div>
                            <div className="controls">
                                <Button size="large" primary
                                    fluid
                                    loading={(this.state.working)}
                                onClick={this.saveDonation}>Send</Button>
                                <br/><br/>
                                <Button size="mini" primary inverted onClick={this.props.cancelVolunteer}>Cancel</Button>
                                
                            </div>
                    </div>
                )
            }
        }

        const renderSlots = ()=>{
            if(!this.props.request.selectedRequest.timeslots){return null;}
            
            if(!this.props.request.selectedRequest.useTimeslots){
                return (
                    <div style={{marginTop:10}}>
                        <Button primary onClick={()=>{this.createDonation(null)}}>Offer Help</Button>
                    </div>
                    
                )
            }

            return (
                <div>
                    <SectionLabel marginTop={30}>Time Slots</SectionLabel>
                    {this.props.request.selectedRequest.timeslots.map((slot, idx)=>{
                return <VolunteerTimeSlot key={idx}  onClick={()=>{this.createDonation(slot.id)}} slot={slot} />                
            })}
                </div>
            )
            

       
        }

        const renderLocations = ()=>{
         
            if(this.props.request.selectedRequest.locations){
                return (
                    <div>
                        <SectionLabel marginTop={40}>Locations</SectionLabel>
                        {this.props.request.selectedRequest.locations.map((loc)=>{
                            return <Location location={loc} geo={loc._geoloc} />
                        })}
                    </div>
                )
        
            } else {
                return (
                    <div>
                        <SectionLabel marginTop={40} marginBottom={10}>Location</SectionLabel>
                        <Location location={this.props.request} geo={this.props.request._geoloc} />
                    </div>
                )
            }
        }
        return (
            <div className="VolunteerModal"
                onClick={()=>{this.props.setVolunteerRequest(null)}}
            >
            
                <style jsx>{`
                    .VolunteerModal {
                        overflow:hidden;
                        height:100vh;
                    }
                   
                    .buttonBar {
                        border-top:1px solid #ccc;
                        display:flex;
                        justify-content: flex-end;
                        padding-top:10px;
                    }

                    .donation-area {
                        background:${colors.hiGrey};
                        padding:20px;
                        position:absolute;
                        bottom:0px;
                        left:0px;
                        right:0px;
                        top:0px;
                        transform : translateY(105%);
                        transition:all 0.3s;
                        box-shadow:0px -3px 5px rgba(0,0,0,0.5);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .donation-area.open {
                        transform : translateY(0%);

                    }
                    .content {
                        flex:1;
                        overflow-y:auto;
                        margin-right:-20px;
                        padding-right:20px;
                    }
                    .wrap {
                        position:absolute;
                        top:20px;
                        left:20px;
                        right:20px;
                        bottom:20px;
                        display:flex;
                        flex-direction:column;
                    }
                `}</style>
                <Dimmer>
                    <ModalFrame>
                        <div className="wrap">
                        <CharityHeader
                            logo={this.props.request.image}
                            name={this.props.request.name}
                            id={this.props.request.charityId}
                            introduction={this.props.request.introduction}
                        />
                        <Divider marginTop={20} marginBottom={0} />
                        
                        <div className="content">
                            <ItemTitle style={{marginBottom:10}} content={this.props.request.selectedRequest.title} />
                            <ItemSubTitle content={this.props.request.selectedRequest.description} />
                            
                            
                            {renderSlots()}

                            {renderLocations()}
                        
                           
                        </div>
                       

                        <div className="buttonBar">
                        
                            <Button inverted primary onClick={()=>{this.props.setVolunteerRequest(null)}}>Close</Button>
                            {(!this.props.request.selectedRequest.timeslots || !this.props.request.selectedRequest.timeslots.length)? <Button primary onClick={()=>{this.createDonation(null)}}>Donate</Button> : null}
                            
                        </div>
                        </div>

                        <div className={(this.props.donation)?"donation-area open" : "donation-area"}>
                            
                            {renderDonationArea()}
                            
                        </div>
                        
                        
                    </ModalFrame>
                
                </Dimmer>
                
            </div>
        )
    }
}

VolunteerModal.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        request : state.volunteer.selectedRef,
        donation : state.volunteer.donation,
        user : state.app.user
    };
}

export default  connect(mapStateProps, {  setVolunteerRequest, volunteer, updateDonationUser, saveVolunteer, cancelVolunteer})(VolunteerModal);
 


// WEBPACK FOOTER //
// ./src/components/common/VolunteerModal.js